import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { StateProvider } from '../state'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'
import { Platforms } from './model_viewers/Platforms'
import { LmsSelection } from './LmsSelection'
import { Issuer } from './model_viewers/Issuer'
import { Client } from './model_viewers/Client'
import { Deployment } from './model_viewers/Deployment'
import { Context } from './model_viewers/Context'
import { ContextCourse } from './model_viewers/ContextCourse'
import { ResourceLink } from './model_viewers/ResourceLink'
import { AlertBox } from './AlertBox'

export const App = ({ isSuperuser }) => {
  const initialState = {
    isSuperuser: isSuperuser,
    tableData: [],
    issuer: null,
    client: null,
    deployment: null,
    context: null,
    clientsTableData: [],
    deploymentsTableData: [],
    contextsTableData: [],
    courseTableData: [],
    reloadSwitch: false,
    resourceLinks: [],
    lineItemResults: [],
    members: [],
    message: null,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateTable':
        return {
          ...state,
          tableData: action.tableData,
        }
      case 'updateIssuer':
        return {
          ...state,
          issuer: action.issuer,
        }
      case 'updateClient':
        return {
          ...state,
          client: action.client,
        }
      case 'updateDeployment':
        return {
          ...state,
          deployment: action.deployment,
        }
      case 'updateContext':
        return {
          ...state,
          context: action.context,
        }
      case 'updateMembers':
        return {
          ...state,
          members: action.members,
        }
      case 'updateCourse':
        return {
          ...state,
          course: action.course,
        }
      case 'updateClientsTable':
        return {
          ...state,
          clientsTableData: action.clientsTableData,
        }
      case 'updateDeploymentsTable':
        return {
          ...state,
          deploymentsTableData: action.deploymentsTableData,
        }
      case 'updateContextsTable':
        return {
          ...state,
          contextsTableData: action.contextsTableData,
        }
      case 'updateCourseTable':
        return {
          ...state,
          courseTableData: action.courseTableData,
        }
      case 'updateResourceLinks':
        return {
          ...state,
          resourceLinks: action.resourceLinks,
        }
      case 'updateLineItemResults':
        return {
          ...state,
          lineItemResults: action.lineItemResults,
        }
      case 'updateMessage':
        return {
          ...state,
          message: action.message,
        }
      case 'reload':
        return {
          ...state,
          reloadSwitch: action.reload,
        }
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <div className="container" style={{ width: '100%' }}>
        <h1 className="me-page-title">LTI 1.3 Management</h1>
        <AlertBox />
        <Router>
          <Switch>
            <Route
              exact
              path="/account/admin_lti13/-/"
              component={LmsSelection}
            />
            <Route
              exact
              path="/account/admin_lti13/-/platforms/:lmsCode/issuers"
              component={Platforms}
            />
            <Route
              exact
              path="/account/admin_lti13/-/platforms/:lmsCode/issuers/:issuerId"
              component={Issuer}
            />
            <Route
              exact
              path="/account/admin_lti13/-/platforms/:lmsCode/issuers/:issuerId/clients/:clientId"
              component={Client}
            />
            <Route
              exact
              path="/account/admin_lti13/-/platforms/:lmsCode/issuers/:issuerId/clients/:clientId/deployments/:deploymentId"
              component={Deployment}
            />
            <Route
              exact
              path="/account/admin_lti13/-/platforms/:lmsCode/issuers/:issuerId/clients/:clientId/deployments/:deploymentId/contexts/:contextId"
              component={Context}
            />
            <Route
              exact
              path="/account/admin_lti13/-/platforms/:lmsCode/issuers/:issuerId/clients/:clientId/deployments/:deploymentId/contexts/:contextId/contextCourses/:contextCourseId"
              component={ContextCourse}
            />
            <Route
              exact
              path="/account/admin_lti13/-/platforms/:lmsCode/issuers/:issuerId/clients/:clientId/deployments/:deploymentId/contexts/:contextId/contextCourses/:contextCourseId/ResourceLinks/:resourceLinkId"
              component={ResourceLink}
            />
          </Switch>
        </Router>
      </div>
    </StateProvider>
  )
}
